import React from "react";
import { AlertCircle } from "lucide-react";
import { Typography } from "./Typography";
import { cn } from "@/lib/utils/cn";

export interface ErrorMessageProps {
  message: string;
  className?: string;
  showIcon?: boolean;
}

export function ErrorMessage({
  message,
  className = "",
  showIcon = true,
}: ErrorMessageProps) {
  return (
    <div
      className={cn("rounded-lg bg-red-50 border border-red-200 p-4", className)}
      role="alert"
    >
      <div className="flex items-start gap-3">
        {showIcon && (
          <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
        )}
        <Typography variant="body" color="text-red-800" className="flex-1">{message}</Typography>
      </div>
    </div>
  );
}
